import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationQuotas, OrganizationService } from 'src/app/services/organization.service';

export type BoundQuota = 'volume' | 'trademarks' | 'cases' | 'crawlerUrls';

/**
 * The i18n key cannot just be the uppercased quota name: 'crawlerUrls' would yield
 * MAX_CRAWLERURLS_EXCEEDED, whereas the backend ErrorIdentifier (and therefore the
 * translation key) is MAX_CRAWLER_URLS_EXCEEDED.
 */
const QUOTA_EXCEEDED_KEY: Record<BoundQuota, string> = {
  volume: 'ORGANIZATION.MAX_VOLUME_EXCEEDED',
  trademarks: 'ORGANIZATION.MAX_TRADEMARKS_EXCEEDED',
  cases: 'ORGANIZATION.MAX_CASES_EXCEEDED',
  crawlerUrls: 'ORGANIZATION.MAX_CRAWLER_URLS_EXCEEDED'
};

@Component({
  selector: 'app-quota-bound-button',
  templateUrl: './quota-bound-button.component.html',
  styleUrls: ['./quota-bound-button.component.scss']
})
export class QuotaBoundButtonComponent {

  @Input() quota?: BoundQuota;
  disabled: boolean = true;
  tooltip: string = '';

  constructor(
    private elementRef: ElementRef,
    private organizationService: OrganizationService,
    private renderer: Renderer2,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.organizationService.quotasObs.subscribe((quotas: OrganizationQuotas | undefined) => {
      if (quotas && this.quota && quotas[this.quota].exceeded) {
        this.disabled = false;
        this.tooltip = this.translate.instant(QUOTA_EXCEEDED_KEY[this.quota]);
        let button = this.elementRef.nativeElement.querySelector('button');
        if (button)
          this.renderer.addClass(button, 'disabled');
      } else {
        this.disabled = true;
      }
    });
  }

}
